export const noteActionTypes = {
    SET_USER_NOTE: 'SET_USER_NOTE',
    FETCH_NOTES_START: 'FETCH_NOTES_START',
    FETCH_NOTES_SUCCESS: 'FETCH_NOTES_SUCCESS',
    FETCH_NOTES_FAILURE: 'FETCH_NOTES_FAILURE',
    SAVE_NOTE_START: 'SAVE_NOTE_START',
    SAVE_NOTE_SUCCESS: 'SAVE_NOTE_SUCCESS',
    SAVE_NOTE_FAILURE: 'SAVE_NOTE_FAILURE',
    UPDATE_NOTE_START: 'UPDATE_NOTE_START',
    UPDATE_NOTE_SUCCESS: 'UPDATE_NOTE_SUCCESS',
    UPDATE_NOTE_FAILURE: 'UPDATE_NOTE_FAILURE',
    DELETE_NOTE_START: 'DELETE_NOTE_START',
    DELETE_NOTE_SUCCESS: 'DELETE_NOTE_SUCCESS',
    DELETE_NOTE_FAILURE: 'DELETE_NOTE_FAILURE',
    SET_SAVE_STATUS: 'SET_SAVE_STATUS',
    SET_UPDATE_STATUS: 'SET_UPDATE_STATUS',
    SET_DELETE_STATUS: 'SET_DELETE_STATUS'
}



